// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"80bcc6c3","453":"875d731a","455":"bdeec48f","977":"2d18f0df"}[chunkId] + ".chunk.js";
};